window.handleATC = function(form, cartBtnSelector = '.fc-cart-btn') {
  const button = form.querySelector(cartBtnSelector);
  const textSpan = button.querySelector('span');
  const variantId = form.querySelector('.fc-atc-variant').value;
  const originalText = textSpan.textContent;

  textSpan.textContent = 'Adding...';
  button.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(() => {
    textSpan.textContent = 'Added!';
    button.style.background = '#28a745';
    button.style.color = '#fff';

    if (window.refreshCartCount) refreshCartCount();

    setTimeout(() => {
      textSpan.textContent = originalText;
      button.style.background = '';
      button.style.color = '';
      button.disabled = false;
    }, 1500);
  })
  .catch(() => {
    textSpan.textContent = 'Error';
    button.style.background = '#dc3545';
    button.style.color = '#fff';

    setTimeout(() => {
      textSpan.textContent = originalText;
      button.style.background = '';
      button.style.color = '';
      button.disabled = false;
    }, 1500);
  });
};
